import React, {Component} from "react"
import Column from "@amzn/meridian/column";
import AslDeviceOverviewContextProvider from "./context/AslDeviceOverviewContext";
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import {ASL, aslMheValidationRoute} from "../../util/RouteConstants";
import {FEATURES, FeatureUtility} from "../../util/FeatureUtility";

/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */

class AslDevicePage extends Component {
    render() {

        const getASLRoutes = () => {
            return FeatureUtility.getFeatureStatus(FEATURES.IS_MHE_VALIDATION_ENABLED) ? [...ASL, aslMheValidationRoute] : ASL;
        }

        return (
            <Column>
                <AslDeviceOverviewContextProvider>
                        <TabLayout routes={getASLRoutes()} location={this.props.location} history={this.props.history}/>
                        <NavigationRoutes routes={getASLRoutes()}/>
                </AslDeviceOverviewContextProvider>
            </Column>
        )
    }
}

export default AslDevicePage;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asldevice/AslDevicePage.js